var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-card',{staticStyle:{"width":"200px"},attrs:{"hoverable":""}},[_c('img',{attrs:{"slot":"cover","src":_vm.imageUrl},slot:"cover"}),_c('a-card-meta',{attrs:{"title":_vm.itemName,"description":_vm.getPrice}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }